import {productBoxSettings, ProductBoxSettings} from '../../../bps/components/productBox/productBoxSettings';

productBoxSettings.showAvailabilityStatus = ['LATER_AVAILABLE', 'NOT_AVAILABLE'];
productBoxSettings.flags.whitelist = ['takeAndPayBenefitText', 'new', 'newVintage'];
productBoxSettings.flags.whitelistTag = ['award', 'stoerer'];
productBoxSettings.flags.whitelistInSet = ['award', 'stoerer'];

export {productBoxSettings, ProductBoxSettings};
